import React from 'react';
import { Draggable } from 'react-beautiful-dnd';


const TaskCard = ({ item, index }) => {
    return (
        <Draggable key={item.id} draggableId={item.id} index={index}>
            {(provided) => (
                <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                >
                    <div className='drag-information'>
                        <p>{item.title}</p>
                        {/* <div className="secondary-details">
                            <p>
                                <span>
                                    {item?.subTitle}
                                </span>
                            </p>
                        </div> */}
                    </div>
                </div>
            )}
        </Draggable>
    );
};

export default TaskCard;

